<template>
	<div :class="['v-alert-container',{ 'v-background': background },{ 'off-top': !show },{ error: error }]" @click="backgroundClick($event)">
		<div class="v-alert" :style="{ position: position || '' }">
			<header><p>{{ header }}</p><div @click="exit(false)" class="x"></div></header>
			<p class="message" v-html="message"></p>
			<input :type="type" v-if="typeof input == 'string'" @keydown="keyDown($event)" v-model:value="input" />
			<div class="v-btns">
				<p class="btn gr" @click="exit(false)">{{ cancel }}</p>
				<p class="btn" @click="exit(typeof input == 'string' ? input : true)" :style="{ backgroundColor: btnColor, color: btnFontColor }">{{ OK }}</p>
			</div>	
		</div>
	</div>
</template>

<script>

var $el;

import { mapState } from 'vuex';

export default {
	props: {
		header: {
			default: 'Message'
		},
		message: {
			default: ''
		},
		input: {
			default: null
		},
		cancel: {
			default: 'no'
		},
		OK: {
			default: 'yes'
		},
		resp: {
			default: () => {}
		},
		position: {
			default: 'absolute'
		},
		background: {
			default: true
		},
		error: {
			default: false
		},
		type: {
			default: 'text'
		},
		btnFontColor: '',
		btnColor: '',
		show: false
	},
	mounted: function() {
		console.log({
			btnColor: this.btnColor,
			btnFontColor: this.btnFontColor
		});
		document.body.appendChild(this.$el);
		this.toogleShow();
		typeof this.input == 'string' && this.$el.querySelector('input').focus();
		if ( typeof this.resp == 'number' ) {
			setTimeout(() => {
				this.exit();
			},this.resp)
		}
	},
	methods: {
		exit: function( resp ) {
			this.toogleShow();
			setTimeout(() => this.$el && this.$el.parentElement && this.$el.parentElement.removeChild(this.$el),350);
			if ( typeof this.resp == 'function' ) this.resp(resp);
			return true;
		},
		keyDown ( e ) {
			e.keyCode == 9 && e.preventDefault();
			[13,9].indexOf(e.keyCode) > -1 && this.exit() && this.resp(this.input);
		},
		toogleShow () {
			setTimeout(() => {
				this.show = !this.show;
				!this.show && ( this.background = false );
			},0);
		},
		backgroundClick ( e ) {
			e.target.classList.contains('v-background') && setTimeout(() => this.show && this.exit(),5);
		}
	}
}

</script>

<style lang="scss">
.btn {
	&:active {
		transform: translate(2px,2px);
	}
}	

.v-alert-container {
	position: fixed;
	top: 0px;
	left: 0px;
	width: 100%;
	height: 100%;
	z-index: 20;
	&.v-background {
		background-color: rgba(50,50,50,0.9);
	}
	&.off-top {
		.v-alert {
			transform: translateY(-1000px);
		}
	}
	&.error {
		header {
			p { color: red; font-size: 17px; }
		}
	}
}	
.v-alert {
	.btn {
		width: 120px;
		margin: 5px;
		text-align: center;
		border-radius: 10px;
	}
	header {
		background-color: white;
		border-bottom: 1px solid #c0c0c0;
		p {
			color: black;
			line-height: 38px;
			text-align: left;
			margin-left: 10px;
			width: calc(100% - 60px);
		}
	}
	.v-btns {
		width: 100%;
		float: left;
		border-top: 1px solid #c0c0c0;
		p:nth-child(1) { float: left };
		p:last-child { float: right; }
		p.btn { line-height: 2; font-size: 17px; }
	}
}

p.btn.gr {
    background-color: grey;
    color: white;
}
p.btn {
	background-color: $font-color;
	color: white;
	text-align: center;
	line-height: 3;
	&:active { transform: translate(2px,2px) }
	&.lg {
		font-size: 24px;
	}
}

.v-alert {
    position: fixed;
    margin-bottom: 100px;
	width: 320px;
	left: 50%;
	margin-left: -160px;
	background-color: white;
	border: 1px solid #c0c0c0;
	transition: transform 0.35s;
	transform: translateY(0px);
	z-index: 100;
	top: 100px;
	z-index: 10;  
	p, input { font-size: 15px }
	.v-btns { padding-top: 3px; }
	.message { margin: 20px; width: calc(100% - 40px); text-align: center; float: left; font-size: 17px; line-height: 1.5; }
	input { font-size: 15px; margin: 0px 0px 20px 65px; padding: 5px; width: calc(100% - 130px); border: 1px solid #c0c0c0; }
    label {
        width: calc(100% - 20px);
        float: left;
        margin: 10px 10px 5px 10px;
        p { font-size: 15px; margin: 9px 5px; width: 120px; float: left; }
		> p:nth-child(2) { 
			width: calc(100% - 143px); height: 30px; background-color: rgba(200,200,200,0.4); border: 1px solid #c0c0c0; margin-top: 0px; 
			span {
				margin-left: 5px;
				line-height: 30px;
			}
		}
        input { float: right; width: calc(100% - 150px); margin: 0px; font-size: 15px; }
		textarea {
			width: calc(100% - 147px);
			padding: 5px;
			font-size: 15px;
			margin: 5px 0px 5px 5px;
			min-width: calc(100% - 147px);
			max-width: calc(100% - 147px);
			min-height: 60px;
    	}
    }
}

div.x { position: absolute; right: -3px; top: 0px; width: 42px; height: 42px; }
div.x:before,div.x:after { content: ''; width: 40px; height: 2px; background-color: rgba(0,0,0,0.4); position: absolute; top: 18px; }
div.x:before { transform: rotate(45deg); }
div.x:after { transform: rotate(-45deg); }
</style>